import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const history = useHistory();
  const { t } = useTranslation('common');

  const handleGoBack = () => {
    history.goBack(); // Go back to the previous page
  };

  const handleGoDashboard = () => {
    history.push('/init');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-4xl font-bold text-red-600 mb-4">
        {t('notFound.title', '404 - Not Found')}
      </h1>
      {/* A genuine 404 — an unmatched URL. This page used to double as the
          permission-denied screen, which is why its body said "you do not have
          permission"; denials now render in place via RouteAccessGate and never
          arrive here. See docs/features/denial-never-navigates/00-OVERVIEW.md (N4). */}
      <p className="text-lg text-gray-700 mb-6">
        {t('notFound.body', 'The page you are looking for does not exist.')}
      </p>
      <div className="flex gap-3">
        <button
          className="px-6 py-3 text-white rounded-md"
          style={{ backgroundColor: '#00B894' }}
          onClick={handleGoBack}
        >
          {t('actions.goBack', 'Go Back')}
        </button>
        <button
          className="px-6 py-3 text-white rounded-md"
          style={{ backgroundColor: '#00B894' }}
          onClick={handleGoDashboard}
        >
          {t('actions.goToDashboard', 'Go to dashboard')}
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
